import { getDerivedStatus, sortOrderTaskByOrderTaskStatus } from './orderTask';

/**
 * Returns a list of all the purchased products (entitlements) that haven't been declined or
 * canceled. Include their fulfillment details to aid in UX.
 *
 * @param {object} orderTasks
 * @returns entitlements
 */

const TYPES_WITH_PENDING = [
  'basic_email',
  'llc_formation',
  'corp_formation',
  'business_kit',
  'business_license_report',
  'annual_report',
  'llc_annual_report'
];

const TYPES_WITH_ACTIVE = [
  'llc_formation',
  'corp_formation',
  'annual_report_service',
  'business_license_report',
  'annual_report',
  'llc_annual_report'
];

export const generateEntitlements = (orderTasks = []) => {
  const entitlements = orderTasks
    // You are only entitled to things that aren't inactive
    ?.filter((orderTask) => (getDerivedStatus(orderTask) !== 'inactive'))
    // Strip out order task status complexity, see comment below.
    ?.sort(sortOrderTaskByOrderTaskStatus)
    ?.reduce((acc, orderTask) => {
      // Ignore order task types we have already processed,
      // as they are not the "best" status we could select.
      if (acc[orderTask.orderTaskType]) {
        return acc;
      }
      return {
        ...acc,
        [orderTask.orderTaskType]: {
          fulfillment: {
            derivedStatus: getDerivedStatus(orderTask),
            ...(TYPES_WITH_PENDING.includes(orderTask.orderTaskType) && {
              isPending: getDerivedStatus(orderTask) === 'pending'
            }),
            ...(TYPES_WITH_ACTIVE.includes(orderTask.orderTaskType) && {
              isActive: getDerivedStatus(orderTask) === 'active'
            }),
            // Add additional order task data here situationally
            ...orderTask
          }
        }
      };
    }, {});
  return {
    has(type) {
      return !!entitlements[type];
    },
    get(type) {
      return entitlements[type];
    },
    all() {
      return entitlements;
    }
  };
};
